export default __webpack_public_path__ + "static/media/103.448ca3e4.gif";